"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InstrumentPositions = _interopRequireDefault(require("../InstrumentPositions"));
var _InstrumentPositionsTabs = _interopRequireDefault(require("../InstrumentPositionsTabs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var InstrumentPositionsWrapperComponent = function InstrumentPositionsWrapperComponent(props) {
  return props.isMarginActive ? /*#__PURE__*/_react["default"].createElement(_InstrumentPositionsTabs["default"], {
    "short": props["short"]
  }) : /*#__PURE__*/_react["default"].createElement(_InstrumentPositions["default"], {
    "short": props["short"],
    showTitle: props.showTitle
  });
};
InstrumentPositionsWrapperComponent.defaultProps = {
  isMarginActive: false
};
InstrumentPositionsWrapperComponent.propTypes = {
  isMarginActive: _propTypes["default"].bool
};
var _default = exports["default"] = InstrumentPositionsWrapperComponent;